import { GLOSSARY } from "../lib/glossary";
import { PageHelp } from "../components/PageHelp";

// Plain-language reference for every domain term, sorted alphabetically.
// Backed by the same glossary the <InfoTip> ⓘ affordance reads from, so the
// two never drift. Part of the "ANANSI, approachable" foundation.
export function Glossary() {
  const entries = Object.values(GLOSSARY).sort((a, b) => a.term.localeCompare(b.term));

  return (
    <div style={{ maxWidth: 760 }}>
      <div style={{ marginBottom: 16 }}>
        <div className="uppercase-label">REFERENCE</div>
        <div style={{ fontFamily: "var(--font-display)", fontSize: 22 }}>Glossary</div>
      </div>
      <PageHelp />
      <dl className="glossary">
        {entries.map((e) => (
          <div className="glossary__row" key={e.term}>
            <dt className="glossary__term">{e.term}</dt>
            <dd className="glossary__def">{e.definition}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
